export const COMPREHENCIVE_QUOTE_DATA = 'COMPREHENCIVE_QUOTE_DATA';
export const COMPREHENCIVE_QUOTE_DATA_BY_ID = 'COMPREHENCIVE_QUOTE_DATA_BY_ID';
export const QUOTE_CONFIGURATION_SUCCESS = 'QUOTE_CONFIGURATION_SUCCESS';
export const CLEAR_QUOTE_CONFIGURATION = 'CLEAR_QUOTE_CONFIGURATION';
